export type ControlSize = 's' | 'm' | 'l';
